import { render, staticRenderFns } from "./HeaderUser.vue?vue&type=template&id=1bedae42&scoped=true&"
import script from "./HeaderUser.vue?vue&type=script&lang=js&"
export * from "./HeaderUser.vue?vue&type=script&lang=js&"
import style0 from "./HeaderUser.vue?vue&type=style&index=0&id=1bedae42&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bedae42",
  null
  
)

export default component.exports